import { EDITOR_MODE, useBlocksConfig } from "@pathwright/blocks-engine"
import { BlockText, QuillEditor } from "@pathwright/blocks/src/shared"
import { TOOLBAR_CONFIG_TYPES } from "@pathwright/ui/src/components/quill/toolbar/QuillToolbar"
import { useCallback, useMemo } from "react"
import { useFlashcard } from "./FlashcardProvider"
import { FlashcardHTMLWrapper } from "./ui"
import {
  calcFontSizeFromCharacterCount,
  hasLegacyHTML,
  hasLegacyImage
} from "./utils"

// The memo is causing odd caching issues no matter what we compare here
const propsAreEqual = (prevProps, nextProps) => {
  if (nextProps.cardIndex !== prevProps.cardIndex) return false
  if (nextProps.mode !== prevProps.mode) return false
  if (nextProps.side !== prevProps.side) return false
  if (nextProps.sideName !== prevProps.sideName) return false

  return true
}

const FlashcardHtml = (props) => {
  const {
    cardIndex,
    updateContent,
    side,
    sideName,
    applyOverlay,
    onSetEditingText,
    mode
  } = props

  const html = side?.html || ""

  const { templateVariables } = useBlocksConfig()
  const { blockID } = useFlashcard()

  const handleChangeHTML = useCallback(
    (html) => {
      updateContent(sideName, "html", html)
    },
    [updateContent, sideName]
  )

  const wrapperStyle = useMemo(
    () =>
      sideName === "back"
        ? {
            borderColor: "#fff"
          }
        : null,
    [sideName]
  )

  const scaledFontSize = useMemo(
    () => calcFontSizeFromCharacterCount(side.html),
    [side.html]
  )

  return (
    <FlashcardHTMLWrapper
      mode={mode}
      applyOverlay={applyOverlay && !hasLegacyImage(side)}
      scaledFontSize={scaledFontSize}
      style={wrapperStyle}
      onFocus={() => onSetEditingText(true)}
      onBlur={() => onSetEditingText(false)}
      className="FlashcardHtmlWrapper"
      id={`${blockID}-flashcard-html-${cardIndex}-${sideName}`}
      aria-live="polite"
    >
      {mode === EDITOR_MODE.EDIT ? (
        <QuillEditor
          autofocus={false}
          toolbar={TOOLBAR_CONFIG_TYPES.SIMPLE}
          createCustomToolbar={({ getMergedToolbarConfig }) =>
            getMergedToolbarConfig({
              config: [{ color: ["rgba(0,0,0)", "rgba(255,255,255)"] }]
            })
          }
          html={html && !hasLegacyHTML(side) ? html : ""}
          onChange={handleChangeHTML}
          className={`flashcard-quill-${cardIndex}-${sideName}`}
          bounds={`.flashcard-quill-${cardIndex}-${sideName}`}
          controlled
        />
      ) : (
        <div>
          <BlockText
            html={side.html && !hasLegacyHTML(side) ? side.html : ""}
            templateContext={templateVariables}
          />
        </div>
      )}
    </FlashcardHTMLWrapper>
  )
}

export default FlashcardHtml
